module.exports = __webpack_public_path__ + "img/check.c3b2f85e.png";